import React from 'react';
import { TableRow, TableCell, Toggle, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from '../editCrossSelling.module.css';

export default function PutForSaleAllRatesRow({ productId, category, forSaleArray, setForSaleArray, ratesArray, event }) {
    const { t } = useTranslation();
    const t_prefix = 'ticket.cross-selling.putForSale';

    const noProducsInSale = React.useMemo(() => {
        return !forSaleArray.find(s => s.rate === null && s.event === event.id)?.is_product_in_sale;
    }, [forSaleArray]);

    const eventForSale = React.useMemo(() => {
        return forSaleArray.find(s => s.rate === null && s.event === event.id);
    }, [forSaleArray]);

    const groupActionToggle = React.useCallback(
        (_, checked, action) => {
            ratesArray
                ?.find(rate => rate.eventId === event.id)
                .rates_list.map(r => {
                    const correspondingRate = forSaleArray.find(s => s.rate === r.id);
                    if (correspondingRate) {
                        correspondingRate[action] = checked;
                    } else {
                        forSaleArray.push({
                            event: event.id,
                            category,
                            is_mandatory_product: action === 'is_mandatory_product' ? checked : false,
                            is_opened_product: action === 'is_opened_product' ? checked : false,
                            is_product_in_sale: false,
                            product: productId,
                            rate: r.id
                        });
                    }
                });
            let i = forSaleArray.findIndex(s => s.rate === null && s.event === event.id);
            if (i !== -1) {
                forSaleArray[i][action] = checked;
            } else {
                forSaleArray.push({
                    event: event.id,
                    category,
                    is_mandatory_product: action === 'is_mandatory_product' ? checked : false,
                    is_opened_product: action === 'is_opened_product' ? checked : false,
                    is_product_in_sale: false,
                    product: productId,
                    rate: null
                });
            }
            setForSaleArray([...forSaleArray]);
        },
        [ratesArray, category, productId, forSaleArray, event]
    );

    const onToggleIcon = React.useCallback(() => {
        ratesArray
            ?.find(rate => rate.eventId === event.id)
            .rates_list.map(r => {
                const correspondingRate = forSaleArray.find(s => s.rate === r.id);
                if (correspondingRate) {
                    correspondingRate.is_product_in_sale = noProducsInSale;
                } else {
                    forSaleArray.push({
                        event: event.id,
                        category,
                        is_mandatory_product: false,
                        is_opened_product: false,
                        is_product_in_sale: noProducsInSale,
                        product: productId,
                        rate: r.id
                    });
                }
            });
        let i = forSaleArray.findIndex(s => s.rate === null && s.event === event.id);
        if (i !== -1) {
            forSaleArray[i].is_product_in_sale = noProducsInSale;
        } else {
            forSaleArray.push({
                event: event.id,
                category,
                is_mandatory_product: false,
                is_opened_product: false,
                is_product_in_sale: noProducsInSale,
                product: productId,
                rate: null
            });
        }
        setForSaleArray([...forSaleArray]);
    }, [ratesArray, category, productId, forSaleArray, noProducsInSale, event]);

    return (
        <TableRow key="rate0" className={Style['top-array-mev']}>
            <TableCell>
                {t(`${t_prefix}.sellOnAllRates`)}
                <TooltipHelp title={t(`${t_prefix}.sellOnAllRatesTooltip`)} mini={false} />
            </TableCell>
            <TableCell>
                <Toggle onChange={(_, { checked }) => groupActionToggle(_, checked, 'is_mandatory_product')} checked={eventForSale?.is_mandatory_product} />
            </TableCell>
            <TableCell>
                <Toggle onChange={(_, { checked }) => groupActionToggle(_, checked, 'is_opened_product')} checked={eventForSale?.is_opened_product} />
            </TableCell>
            <TableCell>
                <Toggle onChange={onToggleIcon} checked={!noProducsInSale} />
            </TableCell>
            <TableCell></TableCell>
        </TableRow>
    );
}
